// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"ac0bb7ad","305":"ac0bb7ad","354":"464ad0f2","544":"4461bee9","932":"5eb6e038","975":"9dadf6d7"}[chunkId] + ".chunk.css";
};